<template>
    <div>
        <v-row>
            <v-col cols="12" md="9" lg="9">
                <v-text-field
                    v-model="search"
                    label="Buscar"
                    placeholder="Digite para buscar..."
                    outlined
                    clearable
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" class="d-flex justify-end">
                <v-btn
                    height="55px"
                    dark
                    class="mr-2 elevation-0"
                    color="#313a46"
                    v-can:permission="'channels-slack#store'" 
                    @click="openModal()"
                >
                    <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :search="search"
            :headers="headers"
            :items="channels"
            :loading="loading"
            item-key="id_channel"
            no-data-text="Nenhum canal encontrado"
        >
            <template v-slot:item.actions="{ item }">
                <v-btn
                    icon
                    color="warning"
                    @click="editChannel(item)"
                >
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                    icon
                    color="error"
                    @click="deleteChannel(item)"
                >
                    <v-icon>mdi-trash-can</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <FormChannels
            :dialog="dialog"
            @close="dialog = false"
            @save="saveChannel"
            @update="updateChannel"
            :channel="channel"
        />
    </div>
</template>
<script>
import toast from "@/commom/toast";
import ChannelsSlack from "@/services/http/rpa/ChannelsSlack";
import FormChannels from "./FormChannels.vue";
export default {
    name: "TableChannels",
    components: {
        FormChannels,
    },
    props: {
        channels: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        dialog: false,
        search: "",
        channel: null,
        headers: [
            { text: "Channel ID", value: "id_channel" },
            { text: "Nome", value: "name" },
            { text: "Tipo", value: "type" },
            { text: "Ações", value: "actions", sortable: false },
        ],
    }),
    methods: {
        openModal() {
            this.dialog = true;
        },

        editChannel(channel) {
            this.dialog = true;
            this.channel = channel;
        },

        async deleteChannel(channel) {
            let res = await this.$swal({
                title: `Deseja apagar o canal ${channel.name} da lista?`,
                text: "Isso não pode ser desfeito",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, apagar canal",
                cancelButtonText: "Não, cancelar",
            });
            if (!res.isConfirmed) return;
            try {
                await ChannelsSlack(channel.id).delete();
                this.$emit("refresh");
                toast("success", "Canal deletado com sucesso");
            } catch (error) {
                toast("error", "Erro ao deletar canal");
            }
        },

        async updateChannel(channel) {
            try {
                await ChannelsSlack(channel.id).update(channel);
                this.$emit("refresh");
                toast("success", "Canal atualizado com sucesso");
            } catch (error) {
                toast("error", "Erro ao atualizar canal");
            }
        },

        async saveChannel(channel) {
            try {
                await ChannelsSlack().store(channel);
                this.$emit("refresh");
                toast("success", "Canal salvo com sucesso");
            } catch (error) {
                toast("error", "Erro ao salvar canal");
            }
        },
    },
}
</script>